import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useGetMyStatsMutation } from "state/api";
import { ReceiptLong, CalendarMonth, CardGiftcard, Medication } from "@mui/icons-material";

const StatCard = ({ title, value, sub, icon, color }) => (
  <Card sx={{ borderLeft: `4px solid ${color}`, borderRadius: 2 }}>
    <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Box>
        <Typography variant="caption" color="textSecondary">{title}</Typography>
        <Typography variant="h4" fontWeight={700}>{value}</Typography>
        {sub && <Typography variant="caption" color="textSecondary">{sub}</Typography>}
      </Box>
      <Box sx={{ color, opacity: 0.6, fontSize: 40 }}>{icon}</Box>
    </CardContent>
  </Card>
);

const MrDashboard = () => {
  const { user } = useSelector((s) => s.auth);
  const [getStats] = useGetMyStatsMutation();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (user?.id) getStats({ EmpNo: user.id }).unwrap().then(setStats).catch(console.error);
  }, [user, getStats]);

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} gutterBottom>Welcome, {user?.username}</Typography>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={6} md={3}>
          <StatCard title="Rx Visits" value={stats?.rx?.count || 0} sub={`${stats?.rx?.total_rx || 0} total Rx`} icon={<ReceiptLong fontSize="inherit" />} color="#9c27b0" />
        </Grid>
        <Grid item xs={6} md={3}>
          <StatCard title="Weekly Reports" value={stats?.weekly?.count || 0} icon={<CalendarMonth fontSize="inherit" />} color="#e91e63" />
        </Grid>
        <Grid item xs={6} md={3}>
          <StatCard title="PSP Kits" value={stats?.psp?.kits || 0} sub={`${stats?.psp?.count || 0} entries`} icon={<CardGiftcard fontSize="inherit" />} color="#ff9800" />
        </Grid>
        <Grid item xs={6} md={3}>
          <StatCard title="Lycored Visits" value={stats?.lycored?.count || 0} icon={<Medication fontSize="inherit" />} color="#4caf50" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MrDashboard;
